import React from 'react';
import PropTypes from 'prop-types';

import isValid from 'date-fns/isValid';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { ColumnDisplay, BoldedItem, TicketSaleDataContainer, DateSubDetails } from './TicketConfirmation.styles';

const DATE_FORMAT = 'E LLLL do h:mm aaa';
const formatDate = (date) => (isValid(date) ? format(date, DATE_FORMAT) : null);

export default function TicketLayout({ ticket }) {
    return (
        <ColumnDisplay>
            <div>
                <BoldedItem>Description</BoldedItem>
                <br />
                {ticket.name}
                {!!ticket.startDate && (
                    <DateSubDetails>
                        Start: <time dateTime={ticket.startDate}>{formatDate(parseISO(ticket.startDate))}</time>
                    </DateSubDetails>
                )}
                {!!ticket.endDate && (
                    <DateSubDetails>
                        End: <time dateTime={ticket.endDate}>{formatDate(parseISO(ticket.endDate))}</time>
                    </DateSubDetails>
                )}
            </div>
            <TicketSaleDataContainer>
                {Object.entries(ticket.saleData).map(([title, value]) => (
                    <div key={title}>
                        <BoldedItem>{title}</BoldedItem>
                        <div>{value}</div>
                    </div>
                ))}
            </TicketSaleDataContainer>
        </ColumnDisplay>
    );
}

TicketLayout.propTypes = {
    ticket: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        saleData: PropTypes.shape({
            price: PropTypes.string,
            quantity: PropTypes.number,
            total: PropTypes.string,
            fee: PropTypes.string,
        }),
    }).isRequired,
};
